import { PreUserAddController } from './pre-user-add.controller';
import { PreUserAddProps } from './pre-user-add.model';

export const PreUserAdd = (props: PreUserAddProps) => {
  return <PreUserAddController {...props} />;
};
